import { Controller } from "@hotwired/stimulus"

// Agency contact fields only make sense when the status says an agency
// represents you, so they stay hidden for every other answer.
export default class extends Controller {
  static targets = ["status", "agencyFields"]
  static values = { agencyStatus: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const isAgency = this.statusTarget.value === this.agencyStatusValue

    this.agencyFieldsTarget.classList.toggle("hidden", !isAgency)
    // Hiding alone is not enough — a hidden input still serializes, which would
    // post agency details for a profile that just said it has no agency.
    this.agencyFieldsTarget.querySelectorAll("input").forEach((input) => {
      input.disabled = !isAgency
    })
  }
}
